import { AnalyticsEvent } from '../models';
import { RegistrationType } from '../platforms/adobe-analytics/models';

export class LoginCompleteEvent implements AnalyticsEvent {
  name = 'LoginCompleteEvent';
  constructor(public readonly loginType: RegistrationType) {}
}
